module.exports = __webpack_public_path__ + "img/mbicon2.5ce9199.webp";